import { Dropdown } from 'components/Input'
import { Font14 } from 'components/Typography'
import styled from 'styled-components'
import theme from 'theme_'

export const StyledSelect = styled(Dropdown)`
  background: ${theme.colors.white};
  box-shadow: inset 0 0 0 1px ${theme.colors.lightGrey};
  border-radius: 8px;
  display: flex;
  transition: all 0.3s ease;
  font-weight: normal;
  ${Font14};
  width: 100%;

  :focus-within {
    box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange};
  }

  .select__dropdown-indicator {
    color: ${theme.colors.otterWarmBlack};
  }

  .select__menu {
    position: absolute;

    background: ${theme.colors.white};
    box-shadow: 0 4px 40px ${theme.colors.commonShadow};
    border-radius: 8px;
  }

  .select__control--is-focused {
    border: none;
    box-shadow: none;
  }

  .select__control {
    width: 100%;
    border: none;
    background: none;

    &:hover {
      border: none;
    }
  }
`
